import { render, staticRenderFns } from "./ModalTableDescription.vue?vue&type=template&id=4670b839"
import script from "./ModalTableDescription.vue?vue&type=script&lang=js"
export * from "./ModalTableDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports